export default "__VITE_ASSET__5fl$ew4q__"